module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowPage"
  }, [_c('div', {
    staticClass: "title-acknowPage"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781429996211_toc01#toctitle1",
      "id": "title1"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ACKNOWLEDGMENTS")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("I owe huge debts of inspiration to the following:\n")])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("Cornelius Eady, who opened a door by approaching me with the idea of writing a play.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("Sarah Stern, who followed through with this idea.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("Tehching “Sam” Hsieh, the Taiwanese-born artist who spent a year (1981 to 1982) living outside in New York City (“The Outdoor Piece”).")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("Linda Montano, who spent a year (1983) tied by an eight-foot rope to Tehching Hsieh.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("Deborah Ash ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("mwalimu")]), _vm._v(") and Hubert Sauper ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("rafiki")]), _vm._v("), who invited me to walk through Tanzania with them.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("The amazing actors and directors of the staged readings, who offered invaluable insights.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("Doug Montgomery, who shared his research into the syntax of the joke.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("Esra Padgett, vernacular consultant and linguist extraordinaire.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("Mel Chin, who urged me not to let people muscle me.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("William Stafford, who pointed out that “the darkness around us is deep.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("Mark Subias and Denise Oswald, who shepherded this book into existence.")])])]), _c('br')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-739ba338","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429996211_ack01.vue
// module id = 66
// module chunks = 0